window.crCrypto = (function() {

	var CryptoJSAesJson = {
		stringify: function(cipherParams) {
			var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
			if (cipherParams.iv) j.iv = cipherParams.iv.toString();
			if (cipherParams.salt) j.s = cipherParams.salt.toString();
			return JSON.stringify(j);
		},
		parse: function(jsonStr) {
			var j = JSON.parse(jsonStr);
			var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
			if (j.iv) {
				cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
			}
			if (j.s) {
				cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
			}
			return cipherParams;
		}
	};

	var encryptedClicked = function(encrypt, decrypt) {
		var clickedEvent = function(event) {
			// console.log(decrypt.textContent.trim());
			var decryptedStr = crCrypto.decrypt(decrypt.textContent.trim(), UCRYPTK);
			// console.log(decryptedStr);
			decrypt.textContent = decryptedStr.replace(/"/g, '');

			// hide the encrypted value
			encrypt.style.display = "none";
			// display the decrypted value
			decrypt.style.display = "";
			// delete listener
			encrypt.removeEventListener("click", clickedEvent, false);
		};
		return clickedEvent;
	};

	return {

		init: function() {
			// search all the crypto blocks
			var blocks = document.querySelectorAll('.cr-crypto');
			for (var i = 0; i < blocks.length; i++) {
				var block = blocks[i];
				var encrypted = block.querySelector('.encrypted');
				var decrypted = block.querySelector('.decrypted');
				// add click event
				encrypted.addEventListener("click", encryptedClicked(encrypted, decrypted));
			}
		},

		/**
		 * Encrypt a message with a provided key.
		 * @param  {String} message message to be encoded
		 * @param  {String} key     key
		 * @return {String}         the message encrypted
		 */
		encrypt: function(message, key) {
			return CryptoJS.AES.encrypt(JSON.stringify(message), key, {format: CryptoJSAesJson}).toString();
		},

		/**
		 * Decrypt a coded message. The message has to be encrypted with a specific format as you can see below.
		 * Example : {"ct":"hVhPi7...", "iv":"9d9bb6d5c8e18038453a79cffae9c3ab", "s":"edbe2d2bc76ec09f"}"
		 * @param  {String} cypherText encoded message
		 * @param  {String} key        key
		 * @return {String}            the message decrypted in utf8
		 */
		decrypt: function(cypherText, key) {
			return CryptoJS.AES.decrypt(cypherText, key, {format: CryptoJSAesJson}).toString(CryptoJS.enc.Utf8);
		}
	};
})();
